import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Lightning, Money, Sparkle, UserFocus } from "@phosphor-icons/react";

const ImageText = ({ bannerIcon, banner, title, imageUrl, index, totalItems }) => {
  const ref = useRef();

  const isMobile = typeof window !== "undefined" && window.innerWidth < 768; // Check if mobile

  // Scroll position setup
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  // Calculate parallax effect for text (slower scroll until last item)
  const yText = useTransform(
    scrollYProgress,
    [0, 1],
    [index === totalItems - 1 ? 0 : 200, -200] // Last item scrolls out smoothly
  );

  // Sudden image transition based on scroll progress
  const yImage = useTransform(
    scrollYProgress,
    [0.25, 0.75], // This determines when the image changes
    ["0%", "100%"]
  );

  return (
    <section ref={ref} className="flex items-center justify-center py-4 md:py-[120px] relative">
      <div className="flex flex-col md:flex-row w-4/5 max-w-5xl justify-between gap-12 items-center h-auto md:h-screen">
        {/* Text content on the left */}
        {isMobile ? (
        <div
          className="flex flex-col items-start justify-start text-left gap-6"

        >
          <div className="flex  flex-row gap-2 px-4 py-2 border border-gray-300 rounded-full">
            {bannerIcon} <div>{banner}</div>
          </div>
          <div className="label-18">{title}</div>
        </div>
        ):(
          <motion.div
          className="flex flex-col items-center md:items-start justify-center  md:justify-start text-center md:text-left gap-6"
          style={{ y: yText }}
        >
          <div className="flex  flex-row gap-2 px-4 py-2 border border-gray-300 rounded-full">
            {bannerIcon} <div>{banner}</div>
          </div>
          <div className="label-18">{title}</div>
        </motion.div>
        )}
        {/* Image with sudden transition on the right */}
     
        {isMobile ? (
       <div
            className="relative"
         
          >
            <img
              src={imageUrl}
              alt={title}
              className="w-[300px] h-[250px] md:h-[480px] md:w-[560px] rounded-lg object-cover"
            />
          </div>
         ): (
          <div className="flex-1 max-w-lg -translate-y-1/2">
          <motion.div
          className="relative"
          style={{ y: yImage }} // Sudden change in image with scroll
        >
          <img
            src={imageUrl}
            alt={title}
            className="w-[300px] h-[250px] md:h-[480px] md:w-[560px] rounded-lg object-cover hidden md:block"
          />
        </motion.div>
        </div>
         )}       
       
    
      </div>
    </section>
  );
};

const Parallax = () => {
  // Define your data
  const data = [
    {
      bannerIcon: <Sparkle size={24} color="#ff2459" />,
      banner: "Hassle free",
      title: "No GST or cancelled cheque required",
      imageUrl: "assets/images/p1.png",
    },
    {
      bannerIcon: <UserFocus size={24} color="#ff2459" />,
      banner: "Know your attendees",
      title: "Say goodbye to the hassle of Google Forms",
      imageUrl: "assets/images/p2.png",
    },
    {
      bannerIcon: <Lightning size={24} color="#ff2459" />,
      banner: "Advanced forms!",
      title: "Ask follow-up questions based on the answers",
      imageUrl: "assets/images/p3.png",
    },
    {
      bannerIcon: <Money size={24} color="#ff2459" />,
      banner: "Get paid on your terms",
      title: "Get money from ticket sales as and when you want",
      imageUrl: "assets/images/p4.png",
    },
  ];

  return (
    <div className="relative">
      {data.map((item, index) => (
        <ImageText
          key={index}
          index={index}
          totalItems={data.length}
          bannerIcon={item.bannerIcon}
          banner={item.banner}
          title={item.title}
          imageUrl={item.imageUrl}
        />
      ))}
    </div>
  );
};

export default Parallax;
